import { GrupoClassificacaoFilter } from './grupo-classificacao-filter';

export class GrupoClassificacaoFilterStorage {
    filter: GrupoClassificacaoFilter;
    filterValues: Map<string, any>;

    constructor(filter: GrupoClassificacaoFilter) {
        this.filter = filter;
        this.filterValues = new Map();
    }
}
